import type { ConversationAndRequester } from 'lib-shared-types-api';
import { createContext } from 'react';

export type ConversationRowContextValue = {
  readonly conversationAndRequester: ConversationAndRequester;
};

export const ConversationRowContext =
  createContext<ConversationRowContextValue>(undefined!);
